<app-maintanance-criterias *ngIf="patientIDLoaded" [patientID]="patientID" />
